"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _radio = require("../styles/radio");

var _containers = require("./containers");

var _spacers = require("./spacers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement(_containers.FlexColumn, null, /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_radio.RadioButtonOuterCircle, {
    disabled: props.disabled,
    onClick: props.onClick,
    selected: props.selected,
    size: props.size
  }, /*#__PURE__*/_react["default"].createElement(_radio.RadioButtonInnerCircle, {
    selected: props.selected,
    size: props.size
  })), /*#__PURE__*/_react["default"].createElement(_spacers.VerticalSpacer, {
    width: "0.2rem"
  }), props.label && /*#__PURE__*/_react["default"].createElement(_radio.RadioButtonLabel, {
    disabled: props.disabled,
    size: props.size,
    labelSize: props.labelSize
  }, props.label)), props.subText && /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_radio.RadioSubTextLeftSpacer, {
    size: props.size
  }), /*#__PURE__*/_react["default"].createElement(_spacers.VerticalSpacer, {
    width: "0.2rem"
  }), /*#__PURE__*/_react["default"].createElement(_radio.RadioButtonSubText, {
    disabled: props.disabled,
    size: props.size,
    labelSize: props.labelSize
  }, props.subText)));
};

exports["default"] = _default;
module.exports = exports["default"];